<template>
  <div class="row cover-row" >
        <div v-for="coverField in coverFieldList" :key="coverField.parameterName" class="px-0 mt-3 pt-3" :class="{'col-lg-12' : coverField.dataType=='Multiset', 'col-lg-3' : coverField.dataType!='Multiset'}" > 
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="(coverField.dataType=='String' || coverField.dataType=='Others')">
                <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                    <input
                        type="text" 
                        :placeholder="coverField.parameterName" 
                        :maxlength="checkMaxLength(coverField, selectedImt)" 
                        v-model="coverField.value"
                        v-on:keydown="validateInput(coverField,$event,selectedImt)"
                        onpaste="return false"
                        class="form-control"
                        :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }"
                        @blur="checkError(coverField, selectedImt); checkValue(coverField);"
                    >
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='DropDown'">
                <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                    <select
                        :placeholder="coverField.parameterName" 
                        v-model="coverField.value"
                        class="form-control"
                        :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }"
                        @blur="checkError(coverField, selectedImt)"
                    >
                    <option disabled selected value="">{{coverField.parameterName}}</option>
                    <option v-for="cover in coverField.domainValues" :key="cover.code" :value="cover.code">{{ cover.name }}</option>
                    </select>
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='Numeric' && coverField.parameterName != '1st Year IDV' && coverField.parameterName != 'My Policy My Premium Discount'">
                <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                    <input 
                        type="text" 
                        :placeholder="coverField.parameterName" 
                        :maxlength="checkMaxLength(coverField, selectedImt)" 
                        v-on:keydown="validateInput(coverField,$event,selectedImt)"
                        v-model="coverField.value"
                        class="form-control"
                        onpaste="return false"
                        :disabled="coverField.parameterName=='Total Trailer Value' || (coverField.parameterName=='Number of Persons' && coverField.coverCode == 'IMT16') || (coverField.parameterName=='No. of Persons' && coverField.coverCode == 'IMT18') 
                        || (coverField.parameterName=='No. of Persons' && coverField.coverCode == 'IMT46')"
                        :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }"
                        @blur="checkError(coverField, selectedImt); checkValue(coverField)+ validateMandatory(coverField, selectedImt)+calculateNoOfDays(coverField,selectedImt)"
                    />
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='Numeric' && coverField.parameterName == '1st Year IDV' && getSavedQuoteData.riskDetails.fuelType.toUpperCase() != 'CNG'">
                <float-label :label="checkParentTP ? 'IDV' : coverField.parameterName" :fixed="isFloat(coverField.value)">
                    <input 
                        type="text" 
                        :placeholder="checkParentTP ? 'IDV' : coverField.parameterName" 
                        :maxlength="checkMaxLength(coverField, selectedImt)" 
                        v-on:keydown="validateInput(coverField,$event,selectedImt)"
                        :disabled="checkParentTP ? true : false"
                        v-model="coverField.value"
                        class="form-control"
                        onpaste="return false"
                        :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }"
                        @blur="checkError(coverField, selectedImt); checkValue(coverField)"
                    />
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='Date' && (coverField.parameterName=='Rally Period From' || coverField.parameterName=='Cover Availed From')">
                <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                <datepicker
                    format="dd/MM/yyyy"
                    :input-class="isInputError(coverField)"
                    :class="{'background-default' : true}"
                    @datePickerBlurred="checkError(coverField,selectedImt)+calculateNoOfDays(coverField,selectedImt)"
                    :disabledDates="disableFromDateImt(coverField)"
                    :placeholder="coverField.parameterName"
                    :value="coverField.parameterName=='Rally Period From' ? state.rallyFromDate : coverField.parameterName=='Cover Availed From' ? state.coverAvailedFromDate : ''"
                    v-model="coverField.value">
                </datepicker>
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='Date' && (coverField.parameterName=='Rally Period To' || coverField.parameterName=='Cover Availed To')">
                <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                <datepicker
                    format="dd/MM/yyyy"
                    :disabled="coverField.parameterName=='Rally Period To' ? !state.rallyFromDate : false"
                    :input-class="isInputError(coverField)"
                    :class="{'disabled-calendar' : applyDisabledClass(coverField), 'background-default' : true}"
                    @datePickerBlurred="checkError(coverField,selectedImt)+calculateNoOfDays(coverField,selectedImt)"
                    :disabledDates="disableToDateImt(coverField)"
                    :placeholder="coverField.parameterName"
                    :value="coverField.parameterName=='Rally Period To' ? state.rallyToDate : ''"
                    v-model="coverField.value">
                </datepicker>
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <!-- laid up section from and to date -->
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='Date' && coverField.parameterName=='Laid up Period From'">
                <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                <datepicker
                    format="dd/MM/yyyy"
                    :input-class="isInputError(coverField)"
                    :class="{'background-default' : true}"
                    @datePickerBlurred="checkError(coverField,selectedImt)"
                    :disabledDates="disableFromDateLaidUp(coverField)"
                    :placeholder="coverField.parameterName"
                    :value="coverField.parameterName=='Laid up Period From' ? state.laidUpFromDate : ''"
                    v-model="coverField.value">
                </datepicker>
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='Date' && coverField.parameterName=='Laid up Period To'">
                <float-label :label="coverField.parameterName" :fixed="isFloat(coverField.value)">
                <datepicker
                    format="dd/MM/yyyy"
                    :disabled="coverField.parameterName=='Laid up Period To' ? !state.laidUpFromDate : false"
                    :input-class="isInputError(coverField)"
                    :class="{'disabled-calendar' : applyDisabledClass(coverField), 'background-default' : true}"
                    @datePickerBlurred="checkError(coverField,selectedImt)"
                    :disabledDates="disableToDateLaidUp(coverField)"
                    :placeholder="coverField.parameterName"
                    :value="coverField.parameterName=='Laid up Period To' ? state.laidUpToDate : ''"
                    v-model="coverField.value">
                </datepicker>
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span> 
            </div>
            <div class="form-group p-0 pl-3 mx-0 my-1" v-if="coverField.dataType=='Multiset'">
                <!-- <float-label :label="coverField.parameterName">
                <select class="form-control" :placeholder="coverField.parameterName" v-model="coverField.value"  @blur="checkError(coverField)" :class="{ 'bgc-error-field': coverField.isMandatory && coverField.errorText!=='' }">
                    <option disabled selected value="">{{coverField.parameterName}}</option>
                    <option v-for="value in coverField.domainValues" :key="value.code" :value="value.code">{{value.name}}</option>
                </select>
                </float-label>
                <span class="error-text"
                    v-if=" coverField.errorText!==''"
                >{{ coverField.errorText}}</span>  -->
                <div class="row m-0">
                    <div class="col-12 p-0">
                        <input type="checkbox" class="bgc-checkbox cover-multiset" :disabled="coverField.isMandatory" :class="{'disable-cover':coverField.isMandatory}" :id="coverField.parameterName" v-model="coverField.value" v-if="false">
                        <label class="form-check-label checkbox-inline pt-2" :for="coverField.parameterName" v-if="coverField.parameterName !== 'Geographical Extension'">
                        <span class="multiset-parameter">{{coverField.parameterName}}</span><span class="multiset-parameter" v-show="coverField.multisetValues.length > 1"> - 1</span></label>
                        <hr class="mb-2" v-show="coverField.value"/>
                        <!-- <div v-if="coverField.parameterName == 'No of Persons'"> -->
                            <AddMultiSetCoverField :startEndorsementSuccess="startEndorsementSuccess" :coverFieldData="coverField.multisetValues" :multisetHeading="coverField.parameterName" :selectedImt="selectedImt" :countPersonList="state.countPersonList" :coverCode="coverField.coverCode" v-if="coverField.multisetValues.length>0 && coverField.value" />
                        <!-- </div> -->
                        <hr :class="{'mt-2' : coverField.parameterName == 'Geographical Extension', 'mt-3' : coverField.parameterName !== 'Geographical Extension'}" v-show="coverField.value"/>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import AddMultiSetCoverField from "./AddMultiSetCoverField.vue";
import { reactive, onUpdated, watch, onMounted, computed } from '@vue/composition-api';
import imtValidation from '@/pages/policyServicing/endorsementGroupType/imtValidation';
import moment from "moment";

export default {
  name: "CoverFieldAttributes",
  props: ["imtCoverList", "selectedImt","getSavedQuoteData",'startEndorsementSuccess'],
  components: {
    FloatLabel,
    Datepicker,
    AddMultiSetCoverField
  },
  setup(props,context) {
    let state = reactive({
      countPersonList : 0,
      // policyTenure : '',
      rallyFromDate : null,
      rallyToDate : null,
      isFirstCall : true,
      coverAvailedFromDate : null,
      coverAvailedToDate : null,
      laidUpFromDate: null,
      laidUpToDate: null,
      totalElecIdv: '',
      totalNonElecIdv: '',
      noOfDays:'',
      coverCompleteData : []
    });
    function checkMaxLength(obj, code){
      if(obj){
          let parameter = obj.parameterName;
          if(parameter == 'Number of Persons')
              return 3;
          if(parameter == 'Total Elec. Acc IDV' || parameter == 'Tot Non-Elec. Acc IDV')
              return 7;
          if(parameter == 'No of Persons' || parameter == 'No. of Persons' || parameter == 'Sum Insured per Trailer' || parameter == 'Sum Insured per Person' || parameter == 'Sum Insured Per Person' || parameter == 'Trailer Capacity' || parameter == 'Trailer Chassis Number' 
          || parameter == 'Trailer Registration No' || parameter == 'Total Trailer Value' || parameter == 'Voluntary Excess' || parameter == 'My Policy My Premium Discount'
          || parameter == 'Name of Person' || parameter == 'No of Employees' || parameter == 'IDV' || parameter == '1st Year IDV' || parameter == 'No of Drivers' || parameter == 'Rally Period Excess' || parameter == 'Rally Period excess'
          || parameter == 'No of Trailers' || parameter == 'No. of Trailers' || parameter == 'CNG/LPG Sum Insured' || parameter == 'Cover Premium for OD' || parameter == 'Cover Premium for TP'){
              return 20;
          }
          if(parameter == 'Certificate Number' || parameter == 'Nominee Name' || parameter == 'Post Laid up Adjustment')
              return 30;
          if(parameter == 'Rally title & Location from' || parameter=='Rally title & Location to')
              return 50;
          if(parameter == 'Description')
              return 100;
      }
    }
    function checkError(obj, code){  
      if(obj){
          imtValidation.checkError(obj, code, props.getSavedQuoteData);
      }
    }
    function checkValue(obj){
      if(obj.value && (obj.parameterName == 'No of Persons' || obj.parameterName == 'No. of Persons' || obj.parameterName == 'Number of Persons' || obj.parameterName == 'No of Drivers' || obj.parameterName == 'No of Trailers' || obj.parameterName == 'No. of Trailers'))
      {
          if(obj.errorText=='' && parseInt(obj.value) > 1){
            let inputCount = parseInt(obj.value);
            if(inputCount > 30){
                if(obj.parameterName == 'No of Trailers' || obj.parameterName == 'No. of Trailers'){
                    state.countPersonList = 9;
                }else{
                    state.countPersonList = 30;
                }
            }
            else if(inputCount > 9 && inputCount <= 30){
                if(obj.parameterName == 'No of Trailers' || obj.parameterName == 'No. of Trailers'){
                    state.countPersonList = 9;
                }else{
                    state.countPersonList = inputCount;
                }
            }
            else{
                state.countPersonList = inputCount;
            }
            for(let i=0; i < coverFieldList.value.length; i++){
                if((coverFieldList.value[i].parameterName == 'Person Detail' || coverFieldList.value[i].parameterName == 'Sum Insured Details' || coverFieldList.value[i].parameterName == 'Nominee Detail' || coverFieldList.value[i].parameterName == 'Trailer Detail') && coverFieldList.value[i].multisetValues){
                    if(coverFieldList.value[i].multisetValues.length < state.countPersonList){
                        for(let j = coverFieldList.value[i].multisetValues.length; j<state.countPersonList; j++){
                            context.root.$set(coverFieldList.value[i].multisetValues, j, JSON.parse(JSON.stringify(coverFieldList.value[i].multisetResponse)));
                            //coverFieldList.value[i].multisetValues[j] = coverFieldList.value[i].multisetResponse; 
                        }
                        if(coverFieldList.value[i].multisetValues){
                            for(let k=0; k<coverFieldList.value[i].multisetValues.length; k++){
                                for(let m=0; m < coverFieldList.value[i].multisetValues[k].length; m++){
                                    if(coverFieldList.value[i].multisetValues[k][m].isMandatory){
                                        context.root.$set(coverFieldList.value[i].multisetValues[k][m],'errorText',"");
                                        context.root.$set(coverFieldList.value[i].multisetValues[k][m],'errorMessage',coverFieldList.value[i].multisetValues[k][m].parameterName+" is required");
                                        context.root.$set(coverFieldList.value[i].multisetValues[k][m],'value',"");
                                    }
                                }
                            }
                        }
                    }
                    else if(coverFieldList.value[i].multisetValues.length > state.countPersonList){
                        coverFieldList.value[i].multisetValues.splice(state.countPersonList, coverFieldList.value[i].multisetValues.length - state.countPersonList);
                    }
                }
            }
              // checkTotalValue();  
          }
          else{
              state.countPersonList = 1;
              for(let i=0; i < coverFieldList.value.length; i++){
                  if((coverFieldList.value[i].parameterName == 'Person Detail' || coverFieldList.value[i].parameterName == 'Sum Insured Details' || coverFieldList.value[i].parameterName == 'Nominee Detail' || coverFieldList.value[i].parameterName == 'Trailer Detail') && coverFieldList.value[i].multisetValues){
                      if(coverFieldList.value[i].multisetValues.length > state.countPersonList){
                          coverFieldList.value[i].multisetValues.splice(state.countPersonList, coverFieldList.value[i].multisetValues.length - state.countPersonList);
                      }
                  }
              }
              // checkTotalValue();
          }
      }else{
          for(let k=0; k < coverFieldList.value.length; k++){
              if(coverFieldList.value[k].parameterName =='No of Persons' || coverFieldList.value[k].parameterName == 'Number of Persons' || coverFieldList.value[k].parameterName == 'No of Drivers' || coverFieldList.value[k].parameterName == 'No of Trailers' || coverFieldList.value[k].parameterName == 'No. of Trailers'){
                  state.countPersonList = coverFieldList.value[k].value ? coverFieldList.value[k].value : 1;
              }
          }
          for(let i=0; i < coverFieldList.value.length; i++){
              if((coverFieldList.value[i].parameterName == 'Person Detail' || coverFieldList.value[i].parameterName == 'Sum Insured Details' || coverFieldList.value[i].parameterName == 'Nominee Detail' || coverFieldList.value[i].parameterName == 'Trailer Detail') && coverFieldList.value[i].multisetValues){
                  if(coverFieldList.value[i].multisetValues.length > state.countPersonList){
                      coverFieldList.value[i].multisetValues.splice(state.countPersonList, coverFieldList.value[i].multisetValues.length - state.countPersonList);
                  }
              }
          }
      }
      if(obj.parameterName == 'No of Trailers' || obj.parameterName == 'No. of Trailers'){
        checkTotalValue();
      }
    }
    function checkTotalValue(){
        let sum = 0;
        for(let k=0; k < coverFieldList.value.length; k++){
            // if(coverFieldList.value[k].dataType == 'Multiset' && (coverFieldList.value[k].parameterName =='Person Detail' || coverFieldList.value[k].parameterName =='Nominee Detail')){
            //     for(let p=0; p<coverFieldList.value[k].multisetValues.length; p++){
            //         for(let m=0; m<coverFieldList.value[k].multisetValues[p].length; m++){
            //             if(coverFieldList.value[k].multisetValues[p][m].parameterName == 'Allocation Percentage'){
            //                 if(coverFieldList.value[k].multisetValues[p][m].value)
            //                     sum = sum + (+coverFieldList.value[k].multisetValues[p][m].value);
            //             }
            //         }
            //     }
            // }
            if(coverFieldList.value[k].dataType == 'Multiset' && coverFieldList.value[k].parameterName =='Trailer Detail'){
                for(let p=0; p<coverFieldList.value[k].multisetValues.length; p++){
                    for(let m=0; m<coverFieldList.value[k].multisetValues[p].length; m++){
                        if(coverFieldList.value[k].multisetValues[p][m].parameterName == 'Sum Insured per Trailer'){
                            if(coverFieldList.value[k].multisetValues[p][m].value)
                                sum = sum + (+coverFieldList.value[k].multisetValues[p][m].value);
                        }
                    }
                }
            }
        }
        // if(sum > 0)
        addTotalVal(sum);
    }
    function validateMandatory(obj, code){
      if(obj.validation[1] == 'validateMandatory'){
          state.totalElecIdv = '';
          state.totalNonElecIdv = '';
          for(let i=0; i<coverFieldList.value.length; i++){
              if(coverFieldList.value[i].parameterName == 'Total Elec. Acc IDV'){
                  if(coverFieldList.value[i].value)
                      state.totalElecIdv = coverFieldList.value[i].value
              }
              if(coverFieldList.value[i].parameterName == 'Tot Non-Elec. Acc IDV'){
                  if(coverFieldList.value[i].value)
                      state.totalNonElecIdv = coverFieldList.value[i].value
              }
          }
          if(state.totalElecIdv == '' && state.totalNonElecIdv ==''){
              for(let i=0; i<coverFieldList.value.length; i++){
                  if(coverFieldList.value[i].parameterName == 'Total Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', coverFieldList.value[i].message[0])
                      context.root.$set(coverFieldList.value[i], 'isMandatory', true)

                  }
                  if(coverFieldList.value[i].parameterName == 'Tot Non-Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', coverFieldList.value[i].message[0])
                      context.root.$set(coverFieldList.value[i], 'isMandatory', true)

                  }
              }
          }
          else if(state.totalElecIdv != ''){
              for(let i=0; i<coverFieldList.value.length; i++){
                  if(coverFieldList.value[i].parameterName == 'Total Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', '')
                      context.root.$set(coverFieldList.value[i], 'isMandatory', true)

                  }
                  if(coverFieldList.value[i].parameterName == 'Tot Non-Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', '')
                      context.root.$set(coverFieldList.value[i], 'isMandatory', false)
                  }
              }
          }
          else if(state.totalNonElecIdv != ''){
              for(let i=0; i<coverFieldList.value.length; i++){
                  if(coverFieldList.value[i].parameterName == 'Total Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', '')
                      context.root.$set(coverFieldList.value[i], 'isMandatory', false)
                  }
                  if(coverFieldList.value[i].parameterName == 'Tot Non-Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', '')
                      context.root.$set(coverFieldList.value[i], 'isMandatory', true)
                  }
              }
          }
          else{
              for(let i=0; i<coverFieldList.value.length; i++){
                  if(coverFieldList.value[i].parameterName == 'Total Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', '')
                  }
                  if(coverFieldList.value[i].parameterName == 'Tot Non-Elec. Acc IDV'){
                      context.root.$set(coverFieldList.value[i], 'errorText', '')
                  }
              }
          }
      }
    }
    function calculateNoOfDays(obj,code){
      if(code == 'IMT58'){
          if(obj.parameterName == 'Cover Availed From')
              state.coverAvailedFromDate = obj.value;
          if(obj.parameterName == 'Cover Availed To')
              state.coverAvailedToDate = obj.value;
          if(obj.parameterName == 'No of days')
              state.noOfDays = obj.value;
          if(state.coverAvailedFromDate != '' && state.coverAvailedToDate != ''){
              let timeDifference = Math.abs(state.coverAvailedFromDate - state.coverAvailedToDate);
              let noOfDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)) + 1;
              for(let i = 0; i<coverFieldList.value.length; i++){
                  if(coverFieldList.value[i].parameterName == 'No of days'){
                      coverFieldList.value[i].value = noOfDays.toString();
                      if(coverFieldList.value[i].value != '' &&  coverFieldList.value[i].errorText != ''){
                          coverFieldList.value[i].errorText = ''
                      }
                  }
              }
          }
          // if(state.coverAvailedFromDate != '' && state.noOfDays != ''){
          //     for(let i = 0; i<coverFieldList.value.length; i++){
          //         if(coverFieldList.value[i].parameterName == 'Cover Availed To'){
          //             coverFieldList.value[i].value = moment(state.coverAvailedFromDate).add(state.noOfDays, 'days').toDate();
          //             if(coverFieldList.value[i].value != '' &&  coverFieldList.value[i].errorText != ''){
          //                 coverFieldList.value[i].errorText = ''
          //             }
          //         }
          //     }
          // }
          // if(state.coverAvailedToDate != '' && state.noOfDays != ''){
          //     for(let i = 0; i<coverFieldList.value.length; i++){
          //         if(coverFieldList.value[i].parameterName == 'Cover Availed From'){
          //             coverFieldList.value[i].value = moment(state.coverAvailedToDate).subtract(state.noOfDays, 'days').toDate();
          //             if(coverFieldList.value[i].value != '' &&  coverFieldList.value[i].errorText != ''){
          //                 coverFieldList.value[i].errorText = ''
          //             }
          //         }
          //     }
          // }
      }
    }
    function addTotalVal(value){
        for(let k=0; k < coverFieldList.value.length; k++){
            if(coverFieldList.value[k].parameterName =='Total Trailer Value'){
                coverFieldList.value[k].value = value;
                if(coverFieldList.value[k].value == 0){
                    coverFieldList.value[k].value = '';
                    context.root.$set(coverFieldList.value[k], 'errorMessageMaxLength', '');
                    checkError(coverFieldList.value[k], props.selectedImt);
                }
                else if(coverFieldList.value[k].value.toString().length > 20){
                    context.root.$set(coverFieldList.value[k], 'errorMessageMaxLength', 'The maximum field length should not be more than 20');
                    checkError(coverFieldList.value[k], props.selectedImt);
                }
                else{
                    context.root.$set(coverFieldList.value[k], 'errorMessageMaxLength', '');
                    checkError(coverFieldList.value[k], props.selectedImt);
                }
                context.parent.forceRerender(value);
                break;
            }
        }
    }
    function isInputError(obj) {
      if(obj.isMandatory)
      {
          if( obj.errorText != '' )
          {
              return 'bgc-input bgc-calendar-icon bgc-error-field';
          }
          else{
              return 'bgc-input bgc-calendar-icon';
          }
      }else{
          return 'bgc-input bgc-calendar-icon';
      }
    }
    function applyDisabledClass(obj){
      if(obj.parameterName == 'Rally Period To'){
          return !state.rallyFromDate;
      }
      if(obj.parameterName == 'Laid up Period To'){
          return !state.laidUpFromDate;
      }
      return false;
    }
    function disableFromDateImt(obj){
      if(obj.parameterName == 'Rally Period From'){
          if(obj.value==null){
              //state.rallyToDate = null;
          }else{
              state.rallyFromDate = obj.value;
          }
          return {
            //   props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate.value ? props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate.value : 
              to : moment(new Date()).startOf('date').toDate(),
              from: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyExpiryDate)).subtract(1,'day').toDate()
          }
      }else if(obj.parameterName == 'Cover Availed From'){
          if(obj.value==null){
              //state.rallyToDate = null;
          }else{
              state.coverAvailedFromDate = obj.value;
          }
          return {
              to : moment(new Date()).startOf('date').toDate(),
              from: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyExpiryDate)).subtract(1,'day').toDate()
          }
      }
    }
    function disableToDateImt(obj){
        // props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate.value ? moment(props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate.value).add(parseInt(props.getSavedQuoteData.motorPolicyBasicDetails.planTenure.split("X")[1]), 'y').toDate() : moment(new Date()).add(parseInt(props.getSavedQuoteData.motorPolicyBasicDetails.planTenure.split("X")[1]), 'y').toDate()
      if(obj.parameterName == 'Rally Period To'){
          state.rallyToDate = obj.value;
          return {
              to : state.rallyFromDate ? state.rallyFromDate : new Date(),
              from: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyExpiryDate)).toDate()
          }
      }else if(obj.parameterName == 'Cover Availed To'){
          state.coverAvailedToDate = obj.value;
          return {
              to : state.coverAvailedFromDate ? state.coverAvailedFromDate : new Date(),
              from: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyExpiryDate)).toDate()
          }
      }
    }
    function disableFromDateLaidUp(obj){
      if(obj.parameterName == 'Laid up Period From'){
          if(obj.value==null){
              //state.rallyToDate = null;
          }else{
              state.laidUpFromDate = obj.value;
          }
          return {
              to : moment(new Date()).startOf('date').toDate(),
              from: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyExpiryDate)).subtract(1,'day').toDate()
          }
      }
    }
    function disableToDateLaidUp(obj){
      if(state.laidUpFromDate){
          return {
              to: new moment(state.laidUpFromDate).add(2, 'month').startOf('date').toDate(),
              from: moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyExpiryDate)).toDate()
          }
      }
    }
    function getDomainList(obj){
      context.parent.callDomainList(obj);
    }
    onMounted(()=>{
        if(coverFieldList.value){
            for(let i=0; i<coverFieldList.value.length; i++){
                if((coverFieldList.value[i].coverCode == 'IMT18') || (coverFieldList.value[i].coverCode == 'IMT15')
                || (coverFieldList.value[i].coverCode == 'IMT17')){
                    setTimeout(() => {
                        checkValue(coverFieldList.value[i]);
                    }, 2000);
                }
            }
        }
      
      // if(props.generateQuoteData.policyDetails.planTenure.value){
      //     props.getSavedQuoteData.motorPolicyBasicDetails.planTenure = props.generateQuoteData.policyDetails.planTenure.value;
      // }else{
      //     if(props.generateQuoteData.businessType == 'RUV' && props.generateQuoteData.policyDetails.planCode.value == '1806'){
      //         props.getSavedQuoteData.motorPolicyBasicDetails.planTenure = '0X1';
      //     }
      // }
    });
    const coverFieldList= computed(()=> props.imtCoverList.find(imt => imt.coverCode === props.selectedImt).coverFields)
    const checkParentTP = computed(()=>{
      let obj = context.root.$store.getters.getMotorParentType;
      if(obj.thirdParty){
          return true;
      }
      return false;
    });
    const onlyNumber = imtValidation.onlyNumber;
    const addressOnly = imtValidation.addressOnly;
    const isFloat =  imtValidation.isFloat;
    const validateInput = imtValidation.validateInput;
    const dateObjFormated = functions.dateObjFormated;
    const ObjDateFormated = functions.ObjDateFormated;
    return {
      state,
      isFloat,
      addressOnly,
      onlyNumber,
      validateMandatory,
      calculateNoOfDays,
      coverFieldList,
      checkParentTP,
      validateInput,
      checkMaxLength,
      ObjDateFormated,
      dateObjFormated,
      getDomainList,
      isInputError,
      applyDisabledClass,
      addTotalVal,
      disableFromDateImt,
      disableToDateImt,
      disableFromDateLaidUp,
      disableToDateLaidUp,
      checkError,
      checkValue
    };
  },
};
</script>
<style scoped>
  .cover-row select.form-control{
    background: white;
    background-image:url("../../../../assets/images/drop-down-arrow.png");
    background-position-x: calc(100% - 10px);
    background-position-y: 50%;
    background-repeat: no-repeat;
  }
  .background-default{
    background-color: #fff;
  }
  .multiset-parameter{
    font-weight: bold;
  }
</style>